module.exports = __webpack_public_path__ + "static/media/RatBlast.ac96f3a9.mp3";